import { css } from '@emotion/react';
import emotionReset from 'emotion-reset';

export const globalStyle = css`
  ${emotionReset};

  *,
  *::after,
  *::before {
    box-sizing: border-box;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  html {
    margin: 0;
    background: #2c2c2c;
    padding: 0;
    font-style: normal;
    font-weight: 400;
    font-family: Pretendard, -apple-system, system-ui, sans-serif;
  }

  html::-webkit-scrollbar {
    display: none;
  }

  body {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-align: center;
    -ms-flex-pack: center;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    font-family: Pretendard, -apple-system, system-ui, sans-serif;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  code {
    font-family:
      source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }

  div#root {
    width: 100%;
    height: 100%;
  }
`;
